'use strict';

import React, {useEffect, useMemo, useState} from 'react';
import {h, Fragment} from 'preact';
import Goods from './Goods';
import supplant from '../../utility/supplant';
import mix from '../../../helpers/mix';
import axios from '../../utility/axios';
import {Link, useLocation, useParams} from 'react-router-dom';
import Breadcrumbs from '../Breadcrumbs';
import {langPath} from '../../utility/url';
import {block, unblock} from '../../../src/block-ui';

export default function Models(props) {
    const [state, setState] = useState(props.models || {});
    const params = useParams();
    const {pathname} = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    useEffect(() => {
        if (props.models && params.model === props.models.url) {
            return;
        }

        const url = supplant('/api/models/model-{model}/tech-{tech}/?locale='+ window.appConfig.locale, {...params});

        block();

        axios.get(url).then(response => {
            setState(response.data);
            unblock();
        });
    }, [props.models, params]);

    return (
        <>
            {state.breadcrumbs && <Breadcrumbs items={state.breadcrumbs.stack} />}

            <div className='m_title'>
                <h1 style={{display: 'inline-block'}}>{state.h1}</h1>

                <div style={{float: 'right'}}>
                    {state.brand && (
                        <a href={state.brand.url} style={{display: 'inline-block', width: '77px', height: '38px'}}>
                            <img data-original={state.brand.image} alt={state.brand.name} className='lazy' />
                        </a>
                    )}
                </div>

                <div style={{clear: 'both'}}></div>
            </div>

            <div className='clear' style={{marginBottom: '20px'}}></div>

            <div id='products' className='wrap_items grid'>
                {state.goods && state.goods.length > 0 ? (
                    <Goods
                        items={state.goods}
                        view='list'
                        url={'/api/models/model-{model}/goods/?start={page}'}
                        pagination={state.pagination}
                        onUpdate={items => {
                            const newState = {...state};
                            newState.goods = items;

                            setState(newState);
                        }}
                    />
                ) : (
                    state.noGoods
                )}
            </div>

            <div className='clear'></div>

            <div
                style={{
                    marginTop: '3rem',
                    columns: '245px auto',
                    fontSize: '8pt',
                    margin: '10px',
                    marginBottom: '2rem',
                    padding: '10px',
                    border: '1px solid #c0cede',
                    borderBottom: '3px solid #e0e0e0',
                    borderRadius: '5px',
                }}>
                {state.nextModels && (
                    <>
                        {state.nextModels.map((model, index) => (
                            <div key={index}>
                                <Link
                                    to={langPath(model.url)}
                                    title={model.title}
                                    dangerouslySetInnerHTML={{__html: model.content}}></Link>
                            </div>
                        ))}
                    </>
                )}
            </div>
        </>
    );
}
